<template>
  <div class="welcome">

    <component v-for="(step, i) in steps" :is="step" v-if="active === i" @next="next"/>

    <el-steps :space="50" :active="active" direction="vertical" finish-status="success">
      <el-step v-for="step in steps" :title="$t('step.' + step)"></el-step>
    </el-steps>

  </div>
</template>

<script>
import AdminModification from 'components/setup-guide/AdminModification'
import OwnerForm from 'components/setup-guide/OwnerForm'
import LocationForm from 'components/setup-guide/LocationForm'
import NetworkConnection from 'components/setup-guide/NetworkConnection'
import IPSetup from 'components/setup-guide/IPSetup'
import ServerDomainSetup from 'components/setup-guide/ServerDomainSetup'
import SSLSetup from 'components/setup-guide/SSLSetup'
import { HOME } from 'router/routes'

export default {
  name: 'welcome',
  data () {
    return {
      active: 0,
      steps: [
        'AdminModification',
        'OwnerForm',
        'LocationForm',
        'NetworkConnection',
        'IpSetup',
        'ServerDomainSetup',
        'SslSetup'
      ]
    }
  },
  methods: {
    next () {
      if (this.active >= (this.steps.length - 1)) {
        this.$router.push({ name: HOME })
      }
      else {
        this.active++
      }
    }
  },

  components: {
    AdminModification,
    OwnerForm,
    LocationForm,
    NetworkConnection,
    IpSetup: IPSetup,
    ServerDomainSetup,
    SslSetup: SSLSetup
  }
}
</script>

<style lang="scss">
.welcome {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: top;
  width: 60%;
  margin: 0 auto;

  .data-form {
    width: 100%;
  }

  .el-steps {
    margin-left: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// Welcome.vue?27f6007e